import { Icon, Text } from '@msc-b2c/shared-components';
import styles from './checklist.module.scss';
import { ChecklistProps } from '@msc-b2c/interfaces/types';

export function Checklist({ text, icon, toggleOpen }: Readonly<ChecklistProps>) {
  return (
    <div className={styles['checklist']}>
      <Icon
        icon={icon}
        styleOption={toggleOpen ? `${styles['']}` : 'disabled'}
      />
      <Text
        text={text}
        tagHtml="span"
        styleOption={toggleOpen ? 'cmp-normal' : 'cmp-normal disabled'}
      />
    </div>
  );
}

export default Checklist;
